import { useCallback, useState } from 'react';

// See https://usehooks.com/useToggle/
export const useToggle = (initialState: boolean = false): [boolean, () => void] => {
  const [state, setState] = useState<boolean>(initialState);

  const toggle = useCallback((): void => setState(s => !s), []);

  return [state, toggle];
};
